/* lua.js generated code 0.3.0 */

HomeSceneAnimation = xClass("HomeSceneAnimation")

function convert(num) {
    num = tonumber(num) || 0
    if (num > 9999) {
        // num -= num % 100
        // return  (num / 10000) + "万"
        return Math.floor(num / 10000) + "万"
    }
    return num
}
function createCoinIcon(coinNumber, position) {

    position = position || require("clover/scene/HomeScene").getInstance().getCoinPosition()
    var coinBtn = cc.CSLoader.createNode("cocos/homeScene_coin_btn.csb")
    var icon = coinBtn.getChildByName("icon")
    var sprite = UIItemBuilder.createPropIcon(GamePropIds.kCoin)
    var size = sprite.getContentSize()
    var iSize = icon.getContentSize()
    sprite.setScale(iSize.width * icon.getScaleX() / size.width * 0.85)
    sprite.setPosition(cc.p(icon.getPosition()))
    coinBtn.addChild(sprite)
    icon.removeFromParent(true)
    sprite.setScale(0.4)
    // coinBtn.setPosition(400, winSize.height - 55 - _safe_area_top)
    // coinBtn.setPosition(400, winSize.height - 55 - _safe_area_top)
    coinBtn.setPosition(position.x, position.y - 21)
    
    // coinBtn.getChildByName("add_btn").setVisible(false)
    // coinBtn.getChildByName("bg").setVisible(false)
    // let coinBg = self.coin_btn.getChildByName("bg")
    // self.coinNumLabel.setPosition(coinBg.getPositionX() + 30 , 23)
    // self.coinNumLabel.setAnchorPoint(0, 0.5)
    // self.coinNumLabel.setAdditionalKerning(-2)
    // self.coin_btn.addChild(self.coinNumLabel)
    var coinNumLabel = cc.Label.createWithBMFont("font/berlinsansfb_30_bluestroke.fnt", "0", cc.TEXT_ALIGNMENT_CENTER)
    // var coinNumLabel = cc.LabelTTF.create('0', FONT_DEF.microsoftYahei_24_blueStroke)
    // let coinBg = coinBtn.getChildByName("bg")
    coinNumLabel.setScale(25/30)
    coinNumLabel.setPosition(30 , 20)
    // coinNumLabel.setPosition(60, 23)
    coinNumLabel.setAnchorPoint(0, 0.5)
    coinNumLabel.setAdditionalKerning(-4)
    coinNumLabel.setString(coinNumber)
    coinBtn.addChild(coinNumLabel)
    return [coinBtn, coinNumLabel]
}
//-add coin before calling this!!
animConfig = table(
    [1, "flyCoinNum", 5],
    [1, "coinFlyTime", 0.2],
    [1, "coinFlyInterval", 0.1]
)
HomeSceneAnimation.createCoinIcon = createCoinIcon
HomeSceneAnimation.setStarDrawInfoBanner = function(banner){
    this.starDrawInfoBanner = banner;
}
HomeSceneAnimation.playGetCoinAnimation = function (num, position, coinScale, callback, animConfig) {
    animConfig = animConfig || table()
    animConfig.flyCoinNum = animConfig.flyCoinNum || 5
    animConfig.coinFlyTime = animConfig.coinFlyTime || 0.2
    animConfig.coinFlyInterval = animConfig.coinFlyInterval || 0.1
    var coinPropId = 2
    var scene = cc.Director.getInstance().getRunningScene()
    if (!scene) {
        return 
    }
    var homeScene = require("clover/scene/HomeScene").getInstance()
    if (!homeScene) {
        return 
    }
    var targetPos
    if (animConfig.targetPos) {
        targetPos = animConfig.targetPos
    } else {
        targetPos = homeScene.getCoinPosition()
        if (this.starDrawInfoBanner){
            targetPos = this.starDrawInfoBanner.getCoinPosition();
        }
    }
    // var targetPos = homeScene.getCoinPosition()
    // if (this.starDrawInfoBanner){
    //     targetPos = this.starDrawInfoBanner.getCoinPosition();
    // }
    var targetScale = 0.6
    var layer = cc.Layer.create()
    scene.addChild(layer, UIPopoutLayoutOrder.kFlyCoinAnimation)
    var coinNumber = UserCoin.getInstance().getCoin() - num
    var coinNumberStr = convert(coinNumber)
    var [coinNode, coinNumLabel] = createCoinIcon(coinNumberStr, targetPos)
    layer.addChild(coinNode)
    var finishCount = 0
    function onFlyFinish() {
        finishCount = finishCount + 1
        coinNumLabel.setString(convert(coinNumber + Math.floor(num / animConfig.flyCoinNum * finishCount)))
        if (finishCount >= animConfig.flyCoinNum) {
            layer.runAction(cc.Sequence.create(cc.DelayTime.create(0.2), cc.CallFunc.create(function () {
                var __VA_ARG = $slice(arguments, 0)
                // infoBanner:setComponentVisible(HomeSceneBannerComponents.kCoin, true)
                if (callback) {
                    callback()
                }
            }), cc.RemoveSelf.create(true)))
        }
    }
    var scale = coinScale || 1
    var $limit22 = animConfig.flyCoinNum
    for (var i = 1; i <= $limit22; i += 1) {
        var coin = cc.Sprite.createWithSpriteFrameName("properties/prop_" + tostring(coinPropId) + ".png")
        coin.setPosition(position)
        coin.setScale(scale)
        layer.addChild(coin)
        var bezierConfig = table(
            [0, cc.p(position.x - 100, position.y + 100)],
            [0, cc.p(targetPos.x - 50, targetPos.y)],
            [0, targetPos]
        )
        coin.runAction(cc.Sequence.create(
            cc.DelayTime.create(animConfig.coinFlyInterval * (i - 1)),
            cc.Spawn.create(
                cc.BezierTo.create(animConfig.coinFlyTime, bezierConfig), 
                cc.ScaleTo.create(animConfig.coinFlyTime, targetScale)
            ), 
            cc.Spawn.create(cc.ScaleTo.create(0.05, targetScale * 1.2), cc.FadeOut.create(0.05)), 
            cc.CallFunc.create(onFlyFinish), 
            cc.RemoveSelf.create(true)
        ))
    }
}
HomeSceneAnimation.playGetCoinAnimation3 = function (config, callback, animConfig) {
    HomeSceneAnimation.playGetCoinAnimation2(config.num, config.pos, config.scale || 0.8, callback, animConfig, config.needNum)
}
HomeSceneAnimation.playGetCoinAnimation2 = function (num, position, coinScale, callback, animConfig, needNum) {
    animConfig = animConfig || table()
    animConfig.flyCoinNum = animConfig.flyCoinNum || 5
    animConfig.coinFlyTime = animConfig.coinFlyTime || 0.7
    animConfig.coinFlyInterval = animConfig.coinFlyInterval || 0.1
    var scene = cc.Director.getInstance().getRunningScene()
    if (!scene) {
        return 
    }
    var homeScene = require("clover/scene/HomeScene").getInstance()
    var targetPos = homeScene.getCoinPosition()
    if (this.starDrawInfoBanner){
        targetPos = this.starDrawInfoBanner.getCoinPosition();
    }
    var layer = cc.Layer.create()
    scene.addChild(layer, UIPopoutLayoutOrder.kFlyCoinAnimation)
    homeScene.hiddenCoinNum()
    var coinNumber = UserCoin.getInstance().getCoin() - num
    var coinNumberStr = convert(coinNumber)
    var [coinNode, coinNumLabel] = createCoinIcon(coinNumberStr, targetPos)
    layer.addChild(coinNode)
    var fileName = "cocos/fly_prop_animation_coingot.csb"
    var coinBatchNode = cc.CSLoader.createNode(fileName)
    coinBatchNode.setAnchorPoint(0.5, 0.5)
    layer.addChild(coinBatchNode, 20)
    coinBatchNode.setPosition(position)
    let numLabel = null
    if (needNum) {
        numLabel = UIItemBuilder.createItemNumber(num, false)
        numLabel.setAnchorPoint(0.5, 0.5)
        numLabel.setPosition(position.x + 25, position.y - 55)
        layer.addChild(numLabel, 21)
        numLabel.setOpacity(0)
        numLabel.runAction(cc.FadeIn.create(0.1))
        coinBatchNode.x += 25
    }
    var actionTimeLine = cc.CSLoader.createTimeline(fileName)
    coinBatchNode.runAction(actionTimeLine)
    var fileName = "cocos/fly_prop_animation_coingot_splash.csb"
    var splash = cc.CSLoader.createNode(fileName)
    splash.setScale(0.5)
    splash.setPosition(targetPos)
    layer.addChild(splash)
    var action = cc.CSLoader.createTimeline(fileName)
    splash.runAction(action)
    splash.setVisible(false)
    function createCoin() {
        FrameLoader.loadImageWithPlist("materials/fly_prop_anim.plist")
        var sprite = cc.Sprite.createWithSpriteFrameName("rotate_coin_0000.png")
        var frames = SpriteUtil.buildFrames("rotate_coin_%04d.png", 0, 6)
        var animate = SpriteUtil.buildAnimate(frames, 1 / 50)
        sprite.play(animate, 0, 0)
        return sprite
    }
    function coinAnim(coin, targetPos) {
        var targetScale = 0.6
        var bezierConfig
        if (targetPos.x > coin.getPositionX()) {
            bezierConfig = table(
                [0, cc.p(coin.getPositionX() + 300, coin.getPositionY())],
                [0, cc.p(targetPos.x, targetPos.y - 50)],
                [0, targetPos]
            )
        } else {
            bezierConfig = table(
                [0, cc.p(coin.getPositionX() - 300, coin.getPositionY() + 300)],
                [0, cc.p(targetPos.x - 50, targetPos.y)],
                [0, targetPos]
            )
        }
        coin.runAction(cc.Sequence.create(cc.EaseSineIn.create(cc.Spawn.create(cc.BezierTo.create(animConfig.coinFlyTime, bezierConfig), cc.ScaleTo.create(animConfig.coinFlyTime, targetScale))), cc.Spawn.create(cc.ScaleTo.create(0.05, targetScale * 1.2), cc.FadeOut.create(0.05)), cc.RemoveSelf.create(true)))
    }
    var firstCoin = true
    actionTimeLine.setLastFrameCallFunc(function () {
        actionTimeLine.clearLastFrameCallFunc()
        numLabel && numLabel.runAction(cc.FadeOut.create(0.1))
        coinBatchNode.runAction(cc.Sequence.create(cc.DelayTime.create(0.1), cc.FadeOut.create(0.3), cc.DelayTime.create(Math.max(0.18 + animConfig.coinFlyInterval * 5 + animConfig.coinFlyTime - 0.4, 0)), cc.CallFunc.create(function () {
            coinBatchNode.removeFromParent(true)
            layer.removeFromParent(false)
            homeScene.showCoinNum()
            if (callback) {
                callback()
            }
        })))
        coinBatchNode.runAction(cc.Repeat.create(cc.Sequence.create(cc.CallFunc.create(function () {
            var coin = createCoin()
            coin.setPosition(cc.pAdd(cc.p(coinBatchNode.getPosition()), cc.p(-25.6, -6)))
            layer.addChild(coin)
            coinAnim(coin, targetPos)
        }), cc.DelayTime.create(0.06)), 5))
        coinBatchNode.runAction(cc.Sequence.create(cc.DelayTime.create(0.18), cc.Repeat.create(cc.Sequence.create(cc.CallFunc.create(function () {
            var coin = createCoin()
            coin.setPosition(cc.pAdd(cc.p(coinBatchNode.getPosition()), cc.p(0.15, 28.95)))
            layer.addChild(coin)
            coinAnim(coin, targetPos)
        }), cc.DelayTime.create(0.06)), 5)))
        splash.runAction(cc.Sequence.create(cc.DelayTime.create(animConfig.coinFlyInterval + animConfig.coinFlyTime), cc.CallFunc.create(function () {
            splash.setVisible(true)
            action.gotoFrameAndPlay(0, false)
        })))
        actionTimeLine.play("part2", false)
    })
    actionTimeLine.play("part1", false)
    return layer
}
function createCashIcon(cashNumber, position) {
    // local winSize = cc.Director:getInstance():getWinSize()
    var cashBtn = cc.CSLoader.createNode("cocos/homeScene_cash_btn.csb")
    var icon = cashBtn.getChildByName("icon")
    var sprite = UIItemBuilder.createPropIcon(GamePropIds.kCash)
    var size = sprite.getContentSize()
    var iSize = icon.getContentSize()
    sprite.setScale(iSize.width * icon.getScaleX() / size.width * 0.85)
    sprite.setPosition(cc.p(icon.getPosition()))
    sprite.setScale(0.4)
    cashBtn.addChild(sprite)
    icon.removeFromParent(true)
    // let homeScene = require("clover/scene/HomeScene").getInstance()
    // if (isWechatGameEnv()) {
    //     cashBtn.setScale(0.9)
    //     let tmpPos = homeScene.getInfoCashPosition()
    //     cashBtn.setPosition(tmpPos.x, tmpPos.y + 3)
    // }else {
        cashBtn.setPosition(position.x, position.y - 21)
    // }
    // cashBtn.getChildByName("add_btn").setVisible(false)
    // cashBtn.getChildByName("bg").setVisible(false)
    var cashNumLabel = cc.Label.createWithBMFont("font/berlinsansfb_30_bluestroke.fnt", "0", cc.TEXT_ALIGNMENT_CENTER)
    cashNumLabel.setScale(25/30)
    cashNumLabel.setPosition(55, 19)
    cashNumLabel.setAdditionalKerning(-4)
    cashNumLabel.setString(cashNumber)
    cashBtn.addChild(cashNumLabel)
    return [cashBtn, cashNumLabel]
}
//-add cash before calling this!!
HomeSceneAnimation.playGetCashAnimation = function (num, position, cashScale, callback,animConfig) {
    animConfig = animConfig || table()

    var FLY_CASH_NUM = 5
    var CASH_FLY_TIME = 0.2
    var CASH_FLY_INTERVAL = 0.1
    var cashPropId = 14
    var scene = cc.Director.getInstance().getRunningScene()
    if (!scene) {
        return 
    }
    // var homeScene = require("clover/scene/HomeScene").getInstance()
    // if (!homeScene) {
    //     return 
    // }
    // var targetPos = homeScene.getCashPosition()
    // if (this.starDrawInfoBanner){
    //     targetPos = this.starDrawInfoBanner.getCashPosition();
    // }
    var targetPos
    if (animConfig.targetPos) {
        targetPos = animConfig.targetPos
    } else {
        var homeScene = require("clover/scene/HomeScene").getInstance()
        targetPos = homeScene.getCashPosition()
        if (this.starDrawInfoBanner){
            targetPos = this.starDrawInfoBanner.getCashPosition();
        }
    }

    var targetScale = 0.6
    var layer = cc.Layer.create()
    scene.addChild(layer, UIPopoutLayoutOrder.kFlyCashAnimation)
    var cashNumber = UserCash.getInstance().getCash() - num
    var cashNumberStr = convert(cashNumber)
    var [cashNode, cashNumLabel] = createCashIcon(cashNumberStr, targetPos)
    layer.addChild(cashNode)
    var finishCount = 0
    function onFlyFinish() {
        finishCount = finishCount + 1
        cashNumLabel.setString(convert(cashNumber + Math.floor(num / FLY_CASH_NUM * finishCount)))
        if (finishCount >= FLY_CASH_NUM) {
            layer.runAction(cc.Sequence.create(cc.DelayTime.create(0.2), cc.CallFunc.create(function () {
                var __VA_ARG = $slice(arguments, 0)
                // infoBanner:setComponentVisible(HomeSceneBannerComponents.kCash, true)
                if (callback) {
                    callback()
                }
            }), cc.RemoveSelf.create(true)))
        }
    }
    var scale = cashScale || 1
    var $limit73 = FLY_CASH_NUM
    for (var i = 1; i <= $limit73; i += 1) {
        var cash = cc.Sprite.createWithSpriteFrameName("properties/prop_" + tostring(cashPropId) + ".png")
        cash.setPosition(position)
        cash.setScale(scale)
        layer.addChild(cash)
        var bezierConfig = table(
            [0, cc.p(position.x - 100, position.y + 100)],
            [0, cc.p(targetPos.x - 50, targetPos.y)],
            [0, targetPos]
        )
        cash.runAction(cc.Sequence.create(
            cc.DelayTime.create(CASH_FLY_INTERVAL * (i - 1)),
            cc.Spawn.create(
                cc.BezierTo.create(CASH_FLY_TIME, bezierConfig), 
                cc.ScaleTo.create(CASH_FLY_TIME, targetScale)
            ), 
            cc.Spawn.create(
                cc.ScaleTo.create(0.05, targetScale * 1.2), 
                cc.FadeOut.create(0.05)
            ), 
            cc.CallFunc.create(onFlyFinish), 
            cc.RemoveSelf.create(true)
        ))
    }
}
HomeSceneAnimation.playGetCashAnimation3 = function (config, callback, animConfig) {
    HomeSceneAnimation.playGetCashAnimation2(config.num, config.pos, config.scale || 0.8, callback, animConfig, config.needNum)
}
HomeSceneAnimation.playGetCashAnimation2 = function (num, position, coinScale, callback, animConfig, needNum) {
    animConfig = animConfig || table()
    animConfig.flyCoinNum = animConfig.flyCoinNum || 5
    animConfig.cashFlyTime = animConfig.cashFlyTime || 0.7
    animConfig.cashFlyInterval = animConfig.cashFlyInterval || 0.1
    var scene = cc.Director.getInstance().getRunningScene()
    if (!scene) {
        return 
    }
    var targetPos
    if (animConfig.targetPos) {
        targetPos = animConfig.targetPos
    } else {
        var homeScene = require("clover/scene/HomeScene").getInstance()
        targetPos = homeScene.getCashPosition()
        if (this.starDrawInfoBanner){
            targetPos = this.starDrawInfoBanner.getCashPosition();
        }
    }
    var layer = cc.Layer.create()
    scene.addChild(layer, UIPopoutLayoutOrder.kFlyCashAnimation)
    var fileName = "cocos/fly_prop_animation_cashgot.csb"
    var cashBatchNode = cc.CSLoader.createNode(fileName)
    cashBatchNode.setScale(coinScale)
    cashBatchNode.setAnchorPoint(0.5, 0.5)
    layer.addChild(cashBatchNode, 20)
    cashBatchNode.setPosition(position)
    let numLabel = null
    if (needNum) {
        numLabel = UIItemBuilder.createItemNumber(num, false)
        numLabel.setAnchorPoint(0.5, 0.5)
        numLabel.setPosition(position.x + 25, position.y - 55)
        layer.addChild(numLabel, 21)
        numLabel.setOpacity(0)
        numLabel.runAction(cc.FadeIn.create(0.1))
        coinBatchNode.x += 25
    }
    var actionTimeLine = cc.CSLoader.createTimeline(fileName)
    cashBatchNode.runAction(actionTimeLine)
    if (!animConfig.targetPos) {
        var cashNumber = UserCash.getInstance().getCash() - num
        var cashNumberStr = convert(cashNumber)
        var [cashNode, cashNumLabel] = createCashIcon(cashNumberStr, targetPos)
        layer.addChild(cashNode)
    }
    function createCash() {
        FrameLoader.loadImageWithPlist("materials/fly_prop_anim.plist")
        var sprite = cc.Sprite.createWithSpriteFrameName("rotate_cash_0000.png")
        var frames = SpriteUtil.buildFrames("rotate_cash_%04d.png", 0, 6)
        var animate = SpriteUtil.buildAnimate(frames, 1 / 50)
        sprite.setScale(coinScale)
        sprite.play(animate, 0, 0)
        return sprite
    }
    function cashAnim(cash, targetPos) {
        var targetScale = 0.6 * coinScale
        var bezierConfig = table(
            [0, cc.p(cash.getPositionX() - 100, cash.getPositionY() + 100)],
            [0, cc.p(targetPos.x - 50, targetPos.y)],
            [0, targetPos]
        )
        cash.runAction(cc.Sequence.create(cc.EaseSineIn.create(cc.Spawn.create(cc.BezierTo.create(animConfig.cashFlyTime, bezierConfig), cc.ScaleTo.create(animConfig.cashFlyTime, targetScale))), cc.Spawn.create(cc.ScaleTo.create(0.05, targetScale * 1.2), cc.FadeOut.create(0.05)), cc.RemoveSelf.create(true)))
    }
    actionTimeLine.setLastFrameCallFunc(function () {
        actionTimeLine.clearLastFrameCallFunc()
        numLabel && numLabel.runAction(cc.FadeOut.create(0.1))
        cashBatchNode.runAction(cc.Sequence.create(cc.DelayTime.create(0.1), cc.FadeOut.create(0.3), cc.DelayTime.create(Math.max(0.18 + animConfig.cashFlyInterval * 5 + animConfig.cashFlyTime - 0.4, 0)), cc.CallFunc.create(function () {
            cashBatchNode.removeFromParent(true)
            layer.removeFromParent(false)
            if (callback) {
                callback()
            }
        })))
        cashBatchNode.runAction(cc.Repeat.create(cc.Sequence.create(cc.CallFunc.create(function () {
            var cash = createCash()
            cash.setPosition(cc.pAdd(cc.p(cashBatchNode.getPosition()), cc.p(-25.6, -6)))
            layer.addChild(cash)
            cashAnim(cash, targetPos)
        }), cc.DelayTime.create(0.06)), 5))
        cashBatchNode.runAction(cc.Sequence.create(cc.DelayTime.create(0.18), cc.Repeat.create(cc.Sequence.create(cc.CallFunc.create(function () {
            var cash = createCash()
            cash.setPosition(cc.pAdd(cc.p(cashBatchNode.getPosition()), cc.p(0.15, 28.95)))
            layer.addChild(cash)
            cashAnim(cash, targetPos)
        }), cc.DelayTime.create(0.06)), 5)))
        actionTimeLine.play("part2", false)
    })
    actionTimeLine.play("part1", false)
}
HomeSceneAnimation.playGetStarAnimation = function (position, starType, starScale, callback) {
    var STAR_FLY_TIME = 0.3
    var scene = cc.Director.getInstance().getRunningScene()
    if (!scene) {
        return 
    }
    var homeScene = require("clover/scene/HomeScene").getInstance()
    if (!homeScene) {
        return 
    }
    //homeScene:highlightInfoBanner()
    var targetPos = homeScene.getStarPosition()
    var targetScale = 0.6
    var layer = cc.Layer.create()
    scene.addChild(layer, UIPopoutLayoutOrder.kFlyCoinAnimation)
    function onFlyFinish() {
        layer.removeFromParent(true)
        // homeScene.returnInfoBanner()
        if (callback) {
            callback()
        }
    }
    var scale = starScale || 1
    var star = cc.Sprite.createWithSpriteFrameName("properties/prop_" + tostring(coinPropId) + ".png")
    coin.setPosition(position)
    coin.setScale(scale)
    layer.addChild(coin)
    var bezierConfig = table(
        [0, cc.p(position.x - 100, position.y + 100)],
        [0, cc.p(targetPos.x - 50, targetPos.y)],
        [0, targetPos]
    )
    coin.runAction(cc.Sequence.create(cc.DelayTime.create(COIN_FLY_INTERVAL * (i - 1)), cc.Spawn.create(cc.BezierTo.create(COIN_FLY_TIME, bezierConfig), cc.ScaleTo.create(COIN_FLY_TIME, targetScale)), cc.Spawn.create(cc.ScaleTo.create(0.05, targetScale * 1.2), cc.FadeOut.create(0.05)), cc.CallFunc.create(onFlyFinish), cc.RemoveSelf.create(true)))
}
HomeSceneAnimation.animTypeNormal = 1
HomeSceneAnimation.animTypeSecond = 2
HomeSceneAnimation.animTypeThe = 3

HomeSceneAnimation.playGetPropAnimation = function (itemList, callback, interval, animType) {
    var animatorCount = 0
    animType = animType || HomeSceneAnimation.animTypeNormal
    function flyFinish() {
        animatorCount = animatorCount - 1
        if (animatorCount <= 0) {
            if (callback) {
                callback()
                callback = null
            }
        }
    }
    var flyItemConfig = table()
    for (var k = 1, v = itemList[1]; v!==undefined&&v!==null; k++, v = itemList[k]) {
        if (v.itemId === GamePropIds.kCoin) {
            animatorCount = animatorCount + 1
            if (animType === HomeSceneAnimation.animTypeSecond) {
                HomeSceneAnimation.playGetCoinAnimation2(v.num, v.pos, v.scale || 0.8, flyFinish)
            } else if (animType === HomeSceneAnimation.animTypeThe) {
                HomeSceneAnimation.playGetCoinAnimation3(v, flyFinish)
            } else {
                HomeSceneAnimation.playGetCoinAnimation(v.num, v.pos, v.scale || 0.8, flyFinish,v.coinAnimConfig)
            }
        } else if (v.itemId === GamePropIds.kCash) {
            animatorCount = animatorCount + 1
            if (animType === HomeSceneAnimation.animTypeSecond) {
                HomeSceneAnimation.playGetCashAnimation2(v.num, v.pos, v.scale || 0.8, flyFinish,v.animConfig)
            } else if (animType === HomeSceneAnimation.animTypeThe) {
                HomeSceneAnimation.playGetCoinAnimation3(v, flyFinish)
            } else {
                HomeSceneAnimation.playGetCashAnimation(v.num, v.pos, v.scale || 0.8, flyFinish,v.cashAnimConfig)
            }
        } else if (v.itemId === GamePropIds.kEnergyInf_1Hour || v.itemId === GamePropIds.kEnergyInf_10Min) {
            animatorCount = animatorCount + 1
            HomeSceneAnimation.playInfiniteEnergyAnim(v.pos, flyFinish, v.itemId )
        } else if (v.itemId === GamePropIds.kCircusGameTicket || v.itemId == GamePropIds.kSalvageGiftAdd5){
            animatorCount = animatorCount + 1
            flyFinish()
        } else {
            table.insert(flyItemConfig, v)
        }
    }
    if ($len(flyItemConfig) > 0) {
        animatorCount = animatorCount + 1
        let bagList = table()
        let profileList = table()
        let startBtnList = table()

        for (let _ = 1, v = flyItemConfig[1]; v; _++, v = flyItemConfig[_]) {
            // if (DressingManager.isDressingId(v.itemId)) {
            //    table.insert(profileList, v)
            //} else {
                if (ItemType.isLevelCollectDoubleProp(v.itemId)){
                    table.insert(startBtnList, v)
                }else if (UserPropData.isDressUp(v.itemId)){
                    table.insert(profileList, v)
                }else{
                    table.insert(bagList, v)
                }
            //}
        }
        if ($len(bagList) > 0) {
            if ($len(profileList) > 0) {
                PropBagAnimation.addItemsToBag(bagList, function () { }, interval)
            } else {
                PropBagAnimation.addItemsToBag(bagList, flyFinish, interval)
            }
        }
        if ($len(profileList) > 0) {
            PropBagAnimation.addItemsToProfile(profileList, flyFinish, interval)
        }
        if ($len(startBtnList) > 0) {
            PropBagAnimation.addItemsToStartBtn(startBtnList, flyFinish, interval)
        }
    }
}
HomeSceneAnimation.playGetChestPropAnimation = function (itemList, chestPos, callback) {
    var itemCount = $len(itemList)
    var targetPos = table()
    var animatorCount = 0
    function flyFinish() {
        animatorCount = animatorCount - 1
        if (animatorCount <= 0) {
            if (callback) {
                callback()
            }
        }
    }
    var scene = cc.Director.getInstance().getRunningScene()
    if (!scene) {
        return 
    }
    var animationLayer = cc.Layer.create()
    scene.addChild(animationLayer, 1100)
    var finishCount = 0
    function popoutFinish() {
        finishCount = finishCount + 1
        if (finishCount >= itemCount) {
            animationLayer.removeFromParent(true)
            var flyItemConfig = table()
            for (var k = 1, v = itemList[1]; v!==undefined&&v!==null; k++, v = itemList[k]) {
                if (v.itemId === GamePropIds.kCoin) {
                    animatorCount = animatorCount + 1
                    HomeSceneAnimation.playGetCoinAnimation(v.num, targetPos[k], 0.8, flyFinish)
                } else {
                    var config = table()
                    config.itemId = v.itemId
                    config.num = v.num
                    config.scale = 0.8
                    config.pos = targetPos[k]
                    table.insert(flyItemConfig, config)
                }
            }
            if ($len(flyItemConfig) > 0) {
                animatorCount = animatorCount + 1
                PropBagAnimation.addItemsToBag(flyItemConfig, flyFinish, 0.15)
            }
        }
    }
    var radius = 180
    var bounceRadius = 200
    var angle = table(
        0,
        40,
        30,
        25,
        25
    )
    for (var k = 1, v = itemList[1]; v!==undefined&&v!==null;  k++, v = itemList[k]) {
        var rewardItem = UIItemBuilder.createProp(v.itemId, v.num)[0]
        rewardItem.setPosition(chestPos.x, chestPos.y)
        rewardItem.setScale(0.8)
        animationLayer.addChild(rewardItem, 10)
        var [boxPosX, boxPosY] = [chestPos.x, chestPos.y]
        boxPosY = boxPosY - 100
        var mid = (itemCount + 1) / 2
        var angle = math.rad((k - mid) * angle[itemCount])
        var targetPos1 = cc.p(boxPosX + Math.sin(angle) * bounceRadius, boxPosY + Math.cos(angle) * bounceRadius)
        var targetPos2 = cc.p(boxPosX + Math.sin(angle) * radius, boxPosY + Math.cos(angle) * radius)
        targetPos[k] = targetPos2
        rewardItem.runAction(cc.Sequence.create(cc.MoveTo.create(0.2, targetPos1), cc.MoveTo.create(0.1, targetPos2), cc.CallFunc.create(popoutFinish)))
    }
}

HomeSceneAnimation.parpareDirectShowPassStar = function (score, oldScore, callback) {
    HomeSceneAnimation.parpareDirectShowPassStarDraw(score, oldScore, callback);
}

HomeSceneAnimation.parpareDirectShowPassStarDraw = function (score, oldScore, callback) {
    var self = this;
    var onInfoSuccess = function(evt){
        var info = evt.data;

        var runningScene = cc.director.getRunningScene();

        self.starDraw = cc.Node.create();
        self.starDraw.setAnchorPoint(0, -0.5);
        self.starDraw.setPosition(cc.winSize.width / 2 , cc.winSize.height - (_G.BANNER_HEIGHT|| (80+_safe_area_top)) - 15 - self.starDraw._contentSize.height / 2);
        runningScene.addChild(self.starDraw, 10000);

        var onResSuccess = function(){
            CfgManager.load("new_chest")
            .then((data) => {
                self.starDrawConfig = data.get("new_chest");
                self.refreshStarDrawBtn(info, true);
                self.showPassStarAnimStarDraw(score, oldScore, callback, true);
                CfgManager.release("new_chest");
            });
        }
        var onResFail = function(){

        }
        preloadWithLoading(["packed/StarDrawIconRes.pack"], onResSuccess, onResFail, onResFail);
    }
    var onInfoFail = function(evt){
    }
    var http = GetStarRewardPoolHttp.new();
    http.addEventListener(Events.kComplete, onInfoSuccess);
    http.addEventListener(Events.kError, onInfoFail);
    http.addEventListener(Events.kCancel, onInfoFail);
    http.load();
}

HomeSceneAnimation.refreshStarDrawBtn = function(info, inGameScene = false, starDraw, config){
    var self = this;
    if (starDraw){
        self.starDraw = starDraw;
    }
    if (config){
        self.starDrawConfig = config;
    }
    if (!self.starDrawConfig) self.starDrawConfig = {};
    if (!config) config = {};

    var canDraw = true;
    var adInterval = self.starDrawConfig.new_chest_ad_interval; // 免费冷却时间
    var drawNeedStar = 0; // 抽奖需要的星星数
    var starChetsInfo = UserManager.getInstance().getStarChestInfo();
    
    if (self.starDraw && !self.starDraw.getChildByName("bg")){
        let bg = cc.Sprite.createWithSpriteFrameName("homeScene/icon_bg.png")
        self.starDraw.addChild(bg, -1, "bg")
        self.starDraw.setAnchorPoint(0, 0)
    }
    if (self.starDraw && !self.starDraw.getChildByName("txt")){
        let text = cc.LabelTTF.create("星星幸运礼", FONT_DEF.microsoftYahei_24_blueStroke)
        text.y = -50
        self.starDraw.addChild(text, 0, "txt")
    }


    // 判断是否还有可以抽的
    var canDrawSmall = false;
    var canDrawBig = false;
    for (const key in info.smallRewards) {
        var data = info.smallRewards[key];
        if (data && !data.gain){
            canDrawSmall = true;
            break
        }
    }
    if (!canDrawSmall){
        for (const key in info.bigRewards) {
            var data = info.bigRewards[key];
            if (data && !data.gain){
                canDrawBig = true;
                break
            }
        }
    }
    if (!canDrawSmall && !canDrawBig){
        canDraw = false;
    }else if(canDrawSmall){
        drawNeedStar = self.starDrawConfig.new_chest_spancost_1;
    }else if(canDrawBig){
        drawNeedStar = self.starDrawConfig.new_chest_spancost_2;
    }

    cc.log("drawNeedStar", drawNeedStar)
    cc.log("canDraw", canDraw)
    cc.log("canDrawSmall", canDrawSmall)
    cc.log("canDrawBig", canDrawBig)

    if (canDraw){
        var now = Localhost.timeInSec();
        var nextAdTime = Math.floor(info.lastAdTime/1000) + adInterval;
        // 先判断免费抽
        if (now > nextAdTime && canDrawSmall){
            self.showStarDrawBubble()
            if (!inGameScene){
                if (self.starDrawStatus == 1){
                    return
                }
            }
            if(self.starDraw) {
                if (self.starDraw.getChildByName("drawNode")){
                    self.starDraw.getChildByName("drawNode").removeFromParent(true);
                }
                var drawNode = cc.CSLoader.createNode("cocos/stardraw_icon_red_envelopes1.csb");
                self.starDraw.addChild(drawNode);
                drawNode.setName("drawNode");
                // drawNode.setPosition(5, 10);
    
                var actionTimeLine = cc.CSLoader.createTimeline("cocos/stardraw_icon_red_envelopes1.csb");
                actionTimeLine.gotoFrameAndPlay(1, 44, true);
                actionTimeLine.setTimeSpeed(0.5);
                drawNode.runAction(actionTimeLine);
                drawNode.setScale(0.6)
            }

            self.starDrawStatus = 1;
            return;
        }
        if (starChetsInfo.starCount >= drawNeedStar){
            self.showStarDrawBubble()
            // 可以星星抽
            if (!inGameScene){
                if (self.starDrawStatus == 2){
                    return
                }
            }
            if(self.starDraw) {
                if (self.starDraw.getChildByName("drawNode")){
                    self.starDraw.getChildByName("drawNode").removeFromParent(true);
                }
                var drawNode = cc.CSLoader.createNode("cocos/stardraw_icon_red_envelopes2.csb");
                self.starDraw.addChild(drawNode);
                drawNode.setName("drawNode");
                // drawNode.setPosition(5, 10);
                drawNode.setScale(0.6)
                var actionTimeLine = cc.CSLoader.createTimeline("cocos/stardraw_icon_red_envelopes2.csb");
                actionTimeLine.gotoFrameAndPlay(1, 92, true);
                actionTimeLine.setTimeSpeed(0.5);
                drawNode.runAction(actionTimeLine);
                // 动画显示的时候特效的框和星星一开始错误显示了，所以这里先改成透明
                drawNode.getChildByName("star_or").setOpacity(0);
                drawNode.getChildByName("star_or+1").setOpacity(0);
                drawNode.getChildByName("bigift2").setOpacity(0);
                drawNode.getChildByName("bigift2+1").setOpacity(0);
            }
            self.starDrawStatus = 2;
            return;
        }else{
            self.hideStarDrawBubble()
            // 星星进度
            // if (!inGameScene){
            //     if (self.starDrawStatus == 3){
            //         return
            //     }
            // }
            if(self.starDraw) {
                if (self.starDraw.getChildByName("drawNode")){
                    self.starDraw.getChildByName("drawNode").removeFromParent(true);
                }
                var drawNode = cc.CSLoader.createNode("cocos/stardraw_icon_red_envelopes4.csb");
                self.starDraw.addChild(drawNode);
                var UIProgressTimer = require("clover/panel/component/common/UIProgressTimer")
                var progress = cc.CSLoader.createNode("cocos/stardraw_icon_progress.csb");
                drawNode.getChildByName("progress2").addChild(progress);
                progress = UIProgressTimer.create(progress);
                progress.setProgress(starChetsInfo.starCount/drawNeedStar);
                drawNode.curStar = starChetsInfo.starCount;
                drawNode.drawNeedStar = drawNeedStar;
                progress.setPosition(24, 12);
                progress.setName("progress");
                drawNode.setName("drawNode");
                // drawNode.setPosition(5, 10);
                drawNode.setScale(0.6)
            }
            self.starDrawStatus = 3;
            // 星星数不够的特殊的可以看广告优惠抽大奖的特殊情况
            if (!SnsProxy.getInstance().allowShare() && canDrawBig && !canDrawSmall){
                var nextBigDrawAdTime = Math.floor(info.lastBigDrawAdTime/1000) + config.new_chest_ad_interval;
                var now = Localhost.timeInSec();
                if (now >= nextBigDrawAdTime && starChetsInfo.starCount >= config.new_chest_spancost_2-config.new_chest_spancost_1){
                    self.showStarDrawBubble()
                }
            }
            return;
        }
    }else{
        self.hideStarDrawBubble()
        // 不可抽奖
        if (!inGameScene){
            if (self.starDrawStatus == 4){
                return
            }
        }
        if(self.starDraw) {
            if (self.starDraw.getChildByName("drawNode")){
                self.starDraw.getChildByName("drawNode").removeFromParent(true);
            }
            var drawNode = cc.CSLoader.createNode("cocos/stardraw_icon_red_envelopes3.csb");
            self.starDraw.addChild(drawNode);
            drawNode.setName("drawNode");
            // drawNode.setPosition(5, 10);
            drawNode.setScale(0.6)
            var actionTimeLine = cc.CSLoader.createTimeline("cocos/stardraw_icon_red_envelopes2.csb");
            actionTimeLine.gotoFrameAndPlay(1, 50, true);
            actionTimeLine.setTimeSpeed(0.5);
            drawNode.runAction(actionTimeLine);
        }
        self.starDrawStatus = 4;
        return;
    }
}

HomeSceneAnimation.showStarDrawBubble = function(){
    var self = this;
    return
    var success = function(){
        if (self.canOpenChestBubble){
            self.canOpenChestBubble.setVisible(true)
            return
        }
        var node = cc.CSLoader.createNode("cocos/get_treasure1_bubblebox_prompt3.csb");
        self.starDraw.addChild(node, MiniHomeSceneLayerDef.kChestBubble);
        node.setPosition(cc.p(5, -80));
        node.getChildByName("txt_content").width = 200;
        node.getChildByName("txt_content").height += 10;
        node.getChildByName("txt_content").y -= 5; 
        node.getChildByName("txt_content").setString(getText("starchest.bubble.text2"));
        node.runAction(cc.repeatForever(cc.sequence(cc.moveBy(1, cc.p(0, 10)), cc.moveBy(1, cc.p(0, -10)))));
        self.canOpenChestBubble = node;
    }
    preloadWithLoading(["packed/GetTreasureBubbleboxPrompt.pack"], success, function () {
        Toast.make(getText("error.tip.load_res_error"))
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))
    })
}

HomeSceneAnimation.hideStarDrawBubble = function(){
    var self = this;
    if (self.canOpenChestBubble){
        self.canOpenChestBubble.setVisible(false)
    }
}

const calculateArray = [
    100,
    10,
    1 
]
HomeSceneAnimation.showPassStarAnimStarDrawV2 = function (material, inGameScene, callback) {
    var self = this;

    if (material == 0){
        
        callback && callback()
        return
    }

    UserManager.getInstance().setStarDrawStarNum(0) //算作已播过动画
    // var star =  QuickCreateAnimNode("cocos/stardraw_icon_starn.csb")

    // let node = cc.Node.create()

    // let added = 0
    // for (let type of calculateArray){
    //     type = tonumber(type)
    //     let value = Math.floor(material % (10 * type) / type)
    //     if (value != 0 || added != 0){
    //         let n = cc.Sprite.createWithSpriteFrameName(`stardraw_icon/${ Math.floor(material % (10 * type) / type) }.png` )
    //         n.x = added * 30
    //         added += 1
    //         node.addChild(n)
    //     }

    // }

    // star.getChildByName("number").setSpriteFrame("uilibrary/placeholder.png")

    // star.actionTimeLine.gotoFrameAndPlay(0, 10, false)
    // star.actionTimeLine.setLastFrameCallFunc(function(){
    //     star.actionTimeLine.clearLastFrameCallFunc()
    //     star.getChildByName("number").addChild(node)
    //     star.actionTimeLine.play("number_in", false)
    //     star.actionTimeLine.setLastFrameCallFunc(function(){
    //         star.actionTimeLine.clearLastFrameCallFunc()
    //         star.getChildByName("number").setVisible(false)
    //         star.getChildByName("x").setVisible(false)
    //         star.actionTimeLine.gotoFrameAndPlay(35, 65, false)
    //         star.actionTimeLine.setLastFrameCallFunc(function(){
    //             star.actionTimeLine.clearLastFrameCallFunc()
    //             callback && callback()
    //         })
    //     })
    // })
    

    // self.starDraw.addChild(star, 10);
    // star.setPosition(10, 10);

    if (!self.starDraw || !self.starDraw.alwaysShow) {
        callback && callback()
        return
    }

    console.log("stardraw playAddMaterialAni material", material)
    // // let worldPos = self.getParent().convertToWorldSpace(self.getPosition())
    let worldPos = self.starDraw.getParent().convertToWorldSpaceAR(cc.p(0,self.starDraw.getPositionY()))
    let position = cc.p(worldPos.x + (worldPos.x > display.width / 2 ? -75 : 75 )* 1.8, worldPos.y)
    let startAni = cc.CSLoader.createNode("cocos/stardraw_icon_common_key.csb")
    startAni.ani  = cc.CSLoader.createTimeline("cocos/stardraw_icon_common_key.csb")
    startAni.setPosition(position)
    // self.addChild(startAni, 1000)

    //设置material
    if (material < 10){
        startAni.getChildByName("bp_9").setSpriteFrame("stardraw_icon/bp_"+ material + ".png" )
        startAni.getChildByName("bp_10").setVisible(false)
    }else if (material < 100 ){
        startAni.getChildByName("bp_9").setSpriteFrame("stardraw_icon/bp_"+ parseInt(material / 10) + ".png" )
        startAni.getChildByName("bp_10").setSpriteFrame("stardraw_icon/bp_"+ material % 10 + ".png" )
    }else {
        callback && callback()
        return
    }


    let scene = cc.Director.getInstance().getRunningScene()
    scene.addChild(startAni, 9999)
    // showNode
    SpriteUtil.findBlendChilds_AddOneOne(startAni, false)
    startAni.runAction(startAni.ani)
    startAni.setScale(0.6)
    startAni.ani.setTimeSpeed(1.3)
    startAni.ani.gotoFrameAndPlay(0, 35, false)
    // startAni.ani.play("appear",false)
    startAni.ani.setLastFrameCallFunc(function(){
        // startAni.ani.play("idle",true)
        // startAni.setVisible(false)
        startAni.ani.clearLastFrameCallFunc()
        startAni.removeFromParent()
        startAni.ani.gotoFrameAndPlay(35, false)
        startAni.ani.setLastFrameCallFunc(function(){
            startAni.ani.clearLastFrameCallFunc()
            startAni.removeFromParent()

        })
        
        HomeSceneAnimation.playGetKeyAnimation(self.starDraw,function(){
            //icon顿顿动画
            // self.ani.play("collect",false)
        },()=>{
            if (callback){
                callback()
            }
        },{
            starScale : 0.6,
            targetScale: 0.3,
            coinStr:`stardraw_icon/common_key1.png`
        });
    })
}
HomeSceneAnimation.beforeOnHitEnd = function (cb) {
    let homeScene = require("clover/scene/HomeScene").getInstance()
    if (!homeScene) {
        cb&&cb()
        return
    }

    let callback = ()=>{
        if (homeScene.blockLayeraLevelAnim)homeScene.blockLayeraLevelAnim.setVisible(true)
        if (homeScene.blockLayer)homeScene.blockLayer.setVisible(true)
        cb&&cb()
    }
    GoldElysiumManager.getInstance().checkPopu(true, callback)

}

HomeSceneAnimation.showPassStarAnimStarDraw = function (score, oldScore, onEnd, inGameScene = false, starDraw) {
    var self = this;
    if (starDraw){
        self.starDraw = starDraw;
    }
    var jumpStarCount = 0;
    let old = oldScore.star + 1,newNum = score.star
    for (let k = old; k <= newNum; k += 1) {
        jumpStarCount = jumpStarCount + 1
    }
    cc.log("jumpStarCount", jumpStarCount, "newNum", newNum)
    function onHitEnd() {

        UserManager.getInstance().addStarChestNewStar(jumpStarCount);
        let totalStar = UserManager.getInstance().getStarChestInfo().starCount;
        DCAssist.userTrack("newchest", "star_change", {star1:jumpStarCount, stars:totalStar});
        if (inGameScene){
            // 前5关是在对局界面内显示星星
        }else{
            onEnd()
        }

        var onInfoSuccess = function(evt){
            cc.log("onInfoSuccess", evt)
            var info = evt.data;
            self.refreshStarDrawBtn(info, true);
            if (inGameScene){
                // 前5关
                onEnd();
            }
        }
        var onInfoFail = function(evt){
            self.isBusy = false;
        }
        var http = GetStarRewardPoolHttp.new();
        http.addEventListener(Events.kComplete, onInfoSuccess);
        http.addEventListener(Events.kError, onInfoFail);
        http.addEventListener(Events.kCancel, onInfoFail);
        http.load();
    }
    // 这里拦截了星星抽奖的回调 应美术要求在这里早些进行存钱罐获取奖励的界面显示
    // let piggyBankShowPanel = ()=>{
        // self.beforeOnHitEnd(()=>{
        //     onHitEnd()
        // })
        onHitEnd()
        // PiggyBankManager.getInstance().passLevelShowPanel(score,oldScore,onHitEnd);

    // }


    // self.starDraw.runAction(cc.sequence(cc.delayTime(0.1), cc.callFunc(piggyBankShowPanel)));
    UserManager.getInstance().setStarDrawStarNum(score.star - oldScore.star + UserManager.getInstance().getStarDrawStarNum()) //存下需要展示的星星数
    // HomeSceneAnimation.showPassStarAnimStarDrawV2(UserManager.getInstance().getStarDrawStarNum(), inGameScene, piggyBankShowPanel, false)

    // if (jumpStarCount == 1 && newNum == 4){
    //     // 蓝色的4星
    //     var star = cc.CSLoader.createNode("cocos/stardraw_icon_star4.csb");
    //     self.starDraw.addChild(star, 10);
    //     star.setPosition(10, 10);
    //     var actionTimeLine = cc.CSLoader.createTimeline("cocos/stardraw_icon_star4.csb");
    //     actionTimeLine.gotoFrameAndPlay(1, 86, false);
    //     actionTimeLine.setTimeSpeed(0.5);
    //     star.runAction(actionTimeLine);
    // }else{
    //     for(var i = 1; i <= jumpStarCount; i++){
    //         var star = cc.CSLoader.createNode("cocos/stardraw_icon_star"+ i +".csb");
    //         self.starDraw.addChild(star, 10);
    //         star.setPosition(10, 10);
    //         var actionTimeLine = cc.CSLoader.createTimeline("cocos/stardraw_icon_star"+ i +".csb");
    //         actionTimeLine.gotoFrameAndPlay(1, 86, false);
    //         actionTimeLine.setTimeSpeed(0.5);
    //         star.runAction(actionTimeLine);
    //     }
    // }

    if (self.starDrawStatus == 3 && self.starDraw){
        var drawNode = self.starDraw.getChildByName("drawNode");
        var progress = drawNode.getChildByName("progress2").getChildByName("progress");
        var actionTimeLine = cc.CSLoader.createTimeline("cocos/stardraw_icon_red_envelopes4.csb");
        actionTimeLine.gotoFrameAndPlay(1, 87, false);
        actionTimeLine.setTimeSpeed(0.5);
        drawNode.runAction(actionTimeLine);

        var p = (drawNode.curStar+jumpStarCount)/drawNode.drawNeedStar;
        if (p >= 1){
            p = 1;
        }
        var refreshProgress = function(){
            progress.setProgress(p, 1.5);
        }
        progress.runAction(cc.sequence(cc.delayTime(1.2), cc.callFunc(refreshProgress)));
    }
}

HomeSceneAnimation.playInfiniteEnergyAnim = function (pos, finishCallback ,itemId) {
    let targetPos = require("clover/scene/HomeScene").getInstance().getEnergyPosition()
    if (this.starDrawInfoBanner){
        targetPos = this.starDrawInfoBanner.getEnergyPosition();
    }
    // let icon = UIItemBuilder.createPropIcon(GamePropIds.kEnergyInf)
    let iconId= itemId || GamePropIds.kEnergyInf
    let icon = UIItemBuilder.createPropIcon(iconId)
    let scene = cc.Director.getInstance().getRunningScene()
    let layer = cc.Layer.create()
    scene.addChild(layer, 1100)
    icon.setPosition(pos.x, pos.y)
    layer.addChild(icon)
    let bezierConfig = table(
        [0, cc.p(pos.x , pos.y + 50)],
        [0, cc.p(targetPos.x - 50, targetPos.y - 100)],
        [0, targetPos]
    )
    icon.runAction(cc.Sequence.create(cc.ScaleTo.create(0.3, 1.64), cc.ScaleTo.create(0.3, 0.95), cc.Spawn.create(cc.Sequence.create(cc.DelayTime.create(0.1), cc.CallFunc.create(finishCallback)), cc.BezierTo.create(0.4, bezierConfig), cc.ScaleTo.create(0.4, 0.45)), cc.Spawn.create(cc.FadeOut.create(0.2), cc.ScaleTo.create(0.2, 1)), cc.CallFunc.create(function () {
        layer && layer.removeFromParent(true)
    })))
}


HomeSceneAnimation.playGetKeyAnimation = function (targetNode,callback,finishCallback,animConfigC) {
    let animConfig = {
        flyCoinNum: 5,
        coinFlyTime: 0.25,
        coinFlyInterval: 0.05,
        coinStr:null,//飞入icon图片
        targetScale:0.4, //飞入时候的缩放值
        starScale:1,
        showNum: 0,//显示数量
        showNumScale: 1,//
        startPosX: 0,//初始位置偏移 
    }
    // 容错处理
    if (!targetNode){
        if (callback){
            callback()
        }
        if (finishCallback){
            finishCallback()
        }
        return
    }
    for (const key in animConfigC) {
        animConfig[key] = animConfigC[key]
    }
    let coinStr = animConfig.coinStr
    let finishCount = 0
    function onFlyFinish() {
        finishCount = finishCount + 1
        if (finishCount == 1 && callback){
            callback()
        }
        if (finishCount >= animConfig.flyCoinNum && finishCallback){
            finishCallback()
        }
    }
    let scene = cc.Director.getInstance().getRunningScene()
    
    let worldPos = targetNode.getParent().convertToWorldSpace(cc.p(targetNode.getPositionX(),targetNode.getPositionY()))
    let dfx = worldPos.x > display.width / 2 ? -75 : 75;
    let position = cc.p(worldPos.x + dfx * 1.8, worldPos.y + animConfig.startPosX)
    let targetScale = animConfig.targetScale
    let startFly = ()=>{
        for (let i = 0; i < animConfig.flyCoinNum; i++) {
            let coin = cc.Sprite.createWithSpriteFrameName(coinStr ? coinStr :"properties/prop_10001.png")
            coin.setPosition(position)
            coin.setScale(animConfig.starScale)
            scene.addChild(coin,UIPopoutLayoutOrder.kFlyCoinAnimation)
            // let bezierConfig = table(
            //     [0, cc.p(position.x, position.y + 0)],
            //     [0, cc.p(worldPos.x - 50, worldPos.y)],
            //     [0, worldPos]
            // )
            let bezierConfig = table(
                [0, cc.p(position.x - 0, position.y + 0)],
                [0, cc.p(worldPos.x + dfx, worldPos.y + 100)],
                [0, worldPos]);
            coin.runAction(cc.Sequence.create(
                cc.DelayTime.create(animConfig.coinFlyInterval * (i - 1)),
                cc.Spawn.create(
                        cc.BezierTo.create(animConfig.coinFlyTime, bezierConfig),
                        cc.ScaleTo.create(animConfig.coinFlyTime, targetScale)
                ),
                cc.Spawn.create(
                        cc.ScaleTo.create(0.05, targetScale * 1.2),
                        cc.FadeOut.create(0.05)),
                cc.CallFunc.create(onFlyFinish),
                cc.RemoveSelf.create(true)
            ))
         
        }
    }
    if (animConfig.showNum > 0){
        let coin = cc.Sprite.createWithSpriteFrameName(coinStr ? coinStr :"properties/prop_10001.png")
        coin.setPosition(position)
        scene.addChild(coin,UIPopoutLayoutOrder.kFlyCoinAnimation)
        let numLabel = cc.Label.createWithBMFont("font/berlinsansfb_30_bluestroke.fnt", "+" + animConfig.showNum)
        coin.addChild(numLabel)
        numLabel.setPosition(coin.width,0)
        numLabel.scale = animConfig.showNumScale
        coin.runAction(cc.Sequence.create(
            cc.DelayTime.create(0.3),
            cc.CallFunc.create(()=>{
                startFly()
            }),
            cc.RemoveSelf.create(true)
        ))
        
    }else{
        startFly()
    }
}
